import { NavLink, useNavigate } from 'react-router-dom';
import { useSchoolAuth } from '../../context/SchoolAuthContext';
import { useToast } from '../../context/ToastContext';

const NAV_ITEMS = [
  { path: '/school/dashboard', icon: '📊', label: 'Dashboard' },
  { path: '/school/students', icon: '👨‍🎓', label: 'Students' },
  { path: '/school/add-student', icon: '➕', label: 'Add Student' },
  { path: '/school/bulk-upload', icon: '📤', label: 'Bulk Upload' },
  { path: '/school/performance', icon: '📈', label: 'Performance' },
  { path: '/school/announcements', icon: '📢', label: 'Announcements' },
  { path: '/school/settings', icon: '⚙️', label: 'Settings' },
];

const SchoolShell = ({ children, title, subtitle }) => {
  const { school, logout } = useSchoolAuth();
  const { success } = useToast();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    success('Logged out');
    navigate('/school/login');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: "'Nunito', sans-serif", background: '#F7F8FC' }}>
      <div style={{ width: '220px', background: '#1A3C6E', display: 'flex', flexDirection: 'column', flexShrink: 0, position: 'fixed', height: '100vh', overflowY: 'auto' }}>
        <div style={{ padding: '20px 16px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ fontSize: '13px', fontWeight: 800, color: '#FF6B00', fontFamily: "'Baloo 2', cursive" }}>MyPersonalGuruji</div>
          <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.4)', marginTop: '2px' }}>School Admin Panel</div>
        </div>
        {school && (
          <div style={{ padding: '14px 16px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
            <div style={{ fontSize: '12px', fontWeight: 800, color: 'white' }}>{school.name}</div>
            <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.4)', marginTop: '2px' }}>CBSE #{school.cbse_affiliation_no}</div>
          </div>
        )}
        <nav style={{ padding: '10px 8px', flex: 1 }}>
          {NAV_ITEMS.map(item => (
            <NavLink key={item.path} to={item.path}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 12px', borderRadius: '8px', textDecoration: 'none', marginBottom: '2px',
                background: isActive ? 'rgba(255,107,0,0.15)' : 'transparent',
                color: isActive ? '#FF6B00' : 'rgba(255,255,255,0.6)',
                fontSize: '12px', fontWeight: isActive ? 800 : 600
              })}>
              <span>{item.icon}</span>{item.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ padding: '12px 8px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <button onClick={handleLogout} style={{ width: '100%', padding: '9px 12px', background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.5)', fontSize: '12px', fontWeight: 600, cursor: 'pointer', textAlign: 'left', borderRadius: '8px' }}>
            🚪 Logout
          </button>
        </div>
      </div>
      <div style={{ marginLeft: '220px', flex: 1, display: 'flex', flexDirection: 'column' }}>
        <div style={{ background: 'white', borderBottom: '1px solid #E2E8F0', padding: '14px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '16px', fontWeight: 800 }}>{title}</div>
            {subtitle && <div style={{ fontSize: '12px', color: '#64748B', marginTop: '2px' }}>{subtitle}</div>}
          </div>
        </div>
        <div style={{ padding: '20px 24px', flex: 1 }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default SchoolShell;
